import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { Dropdown } from 'antd';

// Shared UI Library Components
import { CustomIcon, DiscardModal, EIconName, UserAvatar } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './user-menu.scss';

// Thunks
import { userLogout } from '../../../../store/user/user.thunks';

// Models
import { IUserData } from '../../../../interfaces/user.interfaces';

type TUserMenuProps = {
  user: IUserData | null;
}

export const UserMenu: FC<TUserMenuProps> = (
  { user }: TUserMenuProps
): JSX.Element => {

  const [discardModalOpen, setDiscardModalOpen] = useState<boolean>(false);

  const navigate = useNavigate();
  const dispatch = useDispatch<any>();

  const logout = (): void => {
    dispatch(userLogout());
  }

  const onActionDiscard = (value: boolean) => {
    setDiscardModalOpen(false);
    if (!value) return;
    logout();
  }

  const navigateToProfileSettings = (): void => {
    navigate('profile-settings');
  }

  const openDiscardModal = (): void => {
    setDiscardModalOpen(true);
  }

  return (
    <div className="user-menu">
      <DiscardModal open={ discardModalOpen }
                    onCancel={ (value) => onActionDiscard(value) }
                    title={ 'Are you sure you want to log out?' }/>

      <Dropdown
        rootClassName={ 'user-menu--menu' }
        menu={ {
          items: [
            {
              key: 'profile-settings',
              label: (
                <div className="user-menu--item">
                  <CustomIcon name={ EIconName.ProfileSettingsOn } size={ 'size-lg' }/>
                  Profile Settings
                </div>),
              onClick: navigateToProfileSettings
            },
            {
              key: 'logout-action',
              label: (
                <div className="user-menu--item">
                  <CustomIcon name={ EIconName.Logout } skipSize={ true } size={ 'size-lg' }/>
                  Log Out
                </div>),
              onClick: openDiscardModal
            },
          ]
        } } trigger={ ['click'] } placement="bottomRight" arrow>
        <div className="menu-view">
          <UserAvatar avatarUrl={ user?.photo }/>
          <div className="view-name">{ user?.first_name } { user?.last_name }
          </div>
          <CustomIcon name={ EIconName.ArrowDown }/>
        </div>
      </Dropdown>
    </div>
  )
};
